module.exports = "/_next/static/images/393743bc1ce7b882232e664eef41554e-nuis_light_heart.svg.webp";